// This file is compiled by Webpacker.

import 'quill/dist/quill.snow.css'
import 'flatpickr/dist/flatpickr.min.css'
import '../../assets/stylesheets/flatpickr_admin.css'
import '@hotwired/turbo-rails'
import '../scroll_to_top'
import * as ActiveStorage from '@rails/activestorage'
import { Application } from '@hotwired/stimulus'
import CategoryCarouselController from '../controllers/category_carousel_controller'
import CategoryKindController from '../controllers/category_kind_controller'
import MobileNavController from '../controllers/mobile_nav_controller'
import PromotedCarouselController from '../controllers/promoted_carousel_controller'
import PromotedSliderController from '../controllers/promoted_slider_controller'
import OffersTickerController from '../controllers/offers_ticker_controller'
import ChatScrollController from '../controllers/chat_scroll_controller'
import DropdownController from '../controllers/dropdown_controller'
import ConfirmModalController from '../controllers/confirm_modal_controller'
import FlashToastController from '../controllers/flash_toast_controller'
import ChatComposeController from '../controllers/chat_compose_controller'
import ChatCameraController from '../controllers/chat_camera_controller'
import ChatLocationShareController from '../controllers/chat_location_share_controller'
import ChatVoiceNoteController from '../controllers/chat_voice_note_controller'
import ChatVoicePlayerController from '../controllers/chat_voice_player_controller'
import ChatMessageReactionsController from '../controllers/chat_message_reactions_controller'
import BlockCountdownController from '../controllers/block_countdown_controller'
import ProductCategoryFieldsController from '../controllers/product_category_fields_controller'
import ShopLocationPickerController from '../controllers/shop_location_picker_controller'
import CheckoutFormController from '../controllers/checkout_form_controller'
import AdGalleryController from '../controllers/ad_gallery_controller'
import ClassifiedAdChecklistController from '../controllers/classified_ad_checklist_controller'
import ImagePreviewController from '../controllers/image_preview_controller'
import FormWizardController from '../controllers/form_wizard_controller'
import PromotionRequestController from '../controllers/promotion_request_controller'
import PasswordToggleController from '../controllers/password_toggle_controller'
import FilterFormController from '../controllers/filter_form_controller'
import FileUploadController from '../controllers/file_upload_controller'
import RichEditorController from '../controllers/rich_editor_controller'
import DatetimePickerController from '../controllers/datetime_picker_controller'
import CookieConsentController from '../controllers/cookie_consent_controller'
import AiListingAssistantController from '../controllers/ai_listing_assistant_controller'
import WishlistButtonController from '../controllers/wishlist_button_controller'
import StarRatingController from '../controllers/star_rating_controller'
import VariantPickerController from '../controllers/variant_picker_controller'
import SizeFieldsController from '../controllers/size_fields_controller'
import HeroCarouselController from '../controllers/hero_carousel_controller'
import BannerUploadController from '../controllers/banner_upload_controller'
import LoadMoreController from '../controllers/load_more_controller'
import SettingsTabsController from '../controllers/settings_tabs_controller'
import ImageFieldPreviewController from '../controllers/image_field_preview_controller'
import SearchFieldController from '../controllers/search_field_controller'
import SearchScrollController from '../controllers/search_scroll_controller'
import ChatDisclaimerAudioController from '../controllers/chat_disclaimer_audio_controller'
import SidebarAccordionController from '../controllers/sidebar_accordion_controller'
import BulkModerationController from '../controllers/bulk_moderation_controller'
import EmailBroadcastComposerController from '../controllers/email_broadcast_composer_controller'
import SearchableSelectController from '../controllers/searchable_select_controller'
import DeliveryPromiseController from '../controllers/delivery_promise_controller'
import SellerTipController from '../controllers/seller_tip_controller'
import PrettySelectController from '../controllers/pretty_select_controller'
import PromoCountdownController from '../controllers/promo_countdown_controller'
import CopyTextController from '../controllers/copy_text_controller'
import ProductBulkMoveController from '../controllers/product_bulk_move_controller'
import ProductQuickEditController from '../controllers/product_quick_edit_controller'
import OfficialStoreSliderController from '../controllers/official_store_slider_controller'
import ProductShelfController from '../controllers/product_shelf_controller'
import DeliveryLocationPickerController from '../controllers/delivery_location_picker_controller'
import ProductImportFormProgressController from '../controllers/product_import_form_progress_controller'
import ProductImportPollController from '../controllers/product_import_poll_controller'
import SellerTrustModalController from '../controllers/seller_trust_modal_controller'
import RiderGpsController from '../controllers/rider_gps_controller'
import OrderTrackingMapController from '../controllers/order_tracking_map_controller'
import RiderIdUploadsController from '../controllers/rider_id_uploads_controller'
import OrderRiderProgressController from '../controllers/order_rider_progress_controller'
import RiderChatNotificationController from '../controllers/rider_chat_notification_controller'
import ChatNotificationController from '../controllers/chat_notification_controller'
import RiderTrustModalController from '../controllers/rider_trust_modal_controller'
import DeliveryPinRevealController from '../controllers/delivery_pin_reveal_controller'
import SplitCheckoutController from '../controllers/split_checkout_controller'
import ChatTypingController from '../controllers/chat_typing_controller'
import OrderShopProgressController from '../controllers/order_shop_progress_controller'
import PwaInstallController from '../controllers/pwa_install_controller'
import PageLoaderController from '../controllers/page_loader_controller'
import PermissionTemplatesController from '../controllers/permission_templates_controller'
import QuickSaleFormController from '../controllers/quick_sale_form_controller'
import CouponFormController from '../controllers/coupon_form_controller'
import WebPushController from '../controllers/web_push_controller'
import VisitorPresenceController from '../controllers/visitor_presence_controller'
import PushPresenceController from '../controllers/push_presence_controller'
import ScrollRevealBarController from '../controllers/scroll_reveal_bar_controller'
import VideoFeedController from '../controllers/video_feed_controller'
import FeedLikeController from '../controllers/feed_like_controller'
import FeedSideAdsController from '../controllers/feed_side_ads_controller'
import FeedShareController from '../controllers/feed_share_controller'
import FeedCommentController from '../controllers/feed_comment_controller'
import FeedEntryBadgeController from '../controllers/feed_entry_badge_controller'
import WorkspaceChipsController from '../controllers/workspace_chips_controller'
import SortableListController from '../controllers/sortable_list_controller'
import HomepageSectionFormController from '../controllers/homepage_section_form_controller'
import HomepageSectionPinSearchController from '../controllers/homepage_section_pin_search_controller'
import CategoryCheckboxFilterController from '../controllers/category_checkbox_filter_controller'
import 'channels'

ActiveStorage.start()

const stimulusApplication = Application.start()
stimulusApplication.register('category-carousel', CategoryCarouselController)
stimulusApplication.register('category-kind', CategoryKindController)
stimulusApplication.register('mobile-nav', MobileNavController)
stimulusApplication.register('promoted-carousel', PromotedCarouselController)
stimulusApplication.register('promoted-slider', PromotedSliderController)
stimulusApplication.register('offers-ticker', OffersTickerController)
stimulusApplication.register('chat-scroll', ChatScrollController)
stimulusApplication.register('dropdown', DropdownController)
stimulusApplication.register('confirm-modal', ConfirmModalController)
stimulusApplication.register('flash-toast', FlashToastController)
stimulusApplication.register('chat-compose', ChatComposeController)
stimulusApplication.register('chat-camera', ChatCameraController)
stimulusApplication.register('chat-location-share', ChatLocationShareController)
stimulusApplication.register('chat-voice-note', ChatVoiceNoteController)
stimulusApplication.register('chat-voice-player', ChatVoicePlayerController)
stimulusApplication.register('chat-message-reactions', ChatMessageReactionsController)
stimulusApplication.register('block-countdown', BlockCountdownController)
stimulusApplication.register('product-category-fields', ProductCategoryFieldsController)
stimulusApplication.register('shop-location-picker', ShopLocationPickerController)
stimulusApplication.register('checkout-form', CheckoutFormController)
stimulusApplication.register('ad-gallery', AdGalleryController)
stimulusApplication.register('classified-ad-checklist', ClassifiedAdChecklistController)
stimulusApplication.register('image-preview', ImagePreviewController)
stimulusApplication.register('form-wizard', FormWizardController)
stimulusApplication.register('promotion-request', PromotionRequestController)
stimulusApplication.register('password-toggle', PasswordToggleController)
stimulusApplication.register('filter-form', FilterFormController)
stimulusApplication.register('file-upload', FileUploadController)
stimulusApplication.register('rich-editor', RichEditorController)
stimulusApplication.register('datetime-picker', DatetimePickerController)
stimulusApplication.register('cookie-consent', CookieConsentController)
stimulusApplication.register('ai-listing-assistant', AiListingAssistantController)
stimulusApplication.register('wishlist-button', WishlistButtonController)
stimulusApplication.register('star-rating', StarRatingController)
stimulusApplication.register('variant-picker', VariantPickerController)
stimulusApplication.register('size-fields', SizeFieldsController)
stimulusApplication.register('hero-carousel', HeroCarouselController)
stimulusApplication.register('banner-upload', BannerUploadController)
stimulusApplication.register('load-more', LoadMoreController)
stimulusApplication.register('settings-tabs', SettingsTabsController)
stimulusApplication.register('image-field-preview', ImageFieldPreviewController)
stimulusApplication.register('search-field', SearchFieldController)
stimulusApplication.register('search-scroll', SearchScrollController)
stimulusApplication.register('chat-disclaimer-audio', ChatDisclaimerAudioController)
stimulusApplication.register('sidebar-accordion', SidebarAccordionController)
stimulusApplication.register('bulk-moderation', BulkModerationController)
stimulusApplication.register('email-broadcast-composer', EmailBroadcastComposerController)
stimulusApplication.register('searchable-select', SearchableSelectController)
stimulusApplication.register('pretty-select', PrettySelectController)
stimulusApplication.register('seller-tip', SellerTipController)
stimulusApplication.register('delivery-promise', DeliveryPromiseController)
stimulusApplication.register('promo-countdown', PromoCountdownController)
stimulusApplication.register('copy-text', CopyTextController)
stimulusApplication.register('product-bulk-move', ProductBulkMoveController)
stimulusApplication.register('product-quick-edit', ProductQuickEditController)
stimulusApplication.register('official-store-slider', OfficialStoreSliderController)
stimulusApplication.register('product-shelf', ProductShelfController)
stimulusApplication.register('delivery-location-picker', DeliveryLocationPickerController)
stimulusApplication.register('product-import-form-progress', ProductImportFormProgressController)
stimulusApplication.register('product-import-poll', ProductImportPollController)
stimulusApplication.register('seller-trust-modal', SellerTrustModalController)
stimulusApplication.register('rider-gps', RiderGpsController)
stimulusApplication.register('order-tracking-map', OrderTrackingMapController)
stimulusApplication.register('rider-id-uploads', RiderIdUploadsController)
stimulusApplication.register('order-rider-progress', OrderRiderProgressController)
stimulusApplication.register('rider-chat-notification', RiderChatNotificationController)
stimulusApplication.register('chat-notification', ChatNotificationController)
stimulusApplication.register('rider-trust-modal', RiderTrustModalController)
stimulusApplication.register('delivery-pin-reveal', DeliveryPinRevealController)
stimulusApplication.register('split-checkout', SplitCheckoutController)
stimulusApplication.register('chat-typing', ChatTypingController)
stimulusApplication.register('order-shop-progress', OrderShopProgressController)
stimulusApplication.register('pwa-install', PwaInstallController)
stimulusApplication.register('page-loader', PageLoaderController)
stimulusApplication.register('visitor-presence', VisitorPresenceController)
stimulusApplication.register('push-presence', PushPresenceController)
stimulusApplication.register('permission-templates', PermissionTemplatesController)
stimulusApplication.register('quick-sale-form', QuickSaleFormController)
stimulusApplication.register('coupon-form', CouponFormController)
stimulusApplication.register('web-push', WebPushController)
stimulusApplication.register('scroll-reveal-bar', ScrollRevealBarController)
stimulusApplication.register('video-feed', VideoFeedController)
stimulusApplication.register('feed-like', FeedLikeController)
stimulusApplication.register('feed-side-ads', FeedSideAdsController)
stimulusApplication.register('feed-share', FeedShareController)
stimulusApplication.register('feed-comment', FeedCommentController)
stimulusApplication.register('feed-entry-badge', FeedEntryBadgeController)
stimulusApplication.register('workspace-chips', WorkspaceChipsController)
stimulusApplication.register('sortable-list', SortableListController)
stimulusApplication.register('homepage-section-form', HomepageSectionFormController)
stimulusApplication.register('homepage-section-pin-search', HomepageSectionPinSearchController)
stimulusApplication.register('category-checkbox-filter', CategoryCheckboxFilterController)

const isStandaloneDisplay = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.matchMedia('(display-mode: window-controls-overlay)').matches ||
  window.navigator.standalone === true

const notifyStandaloneClient = (registration) => {
  const worker = registration?.active || navigator.serviceWorker.controller
  if (!worker) return

  worker.postMessage({ type: 'ebazzari:standalone', active: isStandaloneDisplay() })
}

let pushChimeAudio = null
const playPushChime = () => {
  try {
    if (!pushChimeAudio) {
      pushChimeAudio = new window.Audio('/brand/notification-chime.wav')
      pushChimeAudio.preload = 'auto'
      pushChimeAudio.volume = 0.85
    }
    pushChimeAudio.currentTime = 0
    const play = pushChimeAudio.play()
    if (play && typeof play.catch === 'function') play.catch(() => {})
  } catch (_) { /* autoplay may be blocked until a user gesture */ }
}

const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return

  navigator.serviceWorker.addEventListener('message', (event) => {
    const type = event.data?.type
    if (type === 'ebazzari:navigate' && event.data.url) {
      window.location.assign(event.data.url)
      return
    }
    if (type === 'ebazzari:push-sound') playPushChime()
  })

  // Unlock audio after first gesture so background push chimes can play.
  const unlockPushChime = () => {
    try {
      if (!pushChimeAudio) {
        pushChimeAudio = new window.Audio('/brand/notification-chime.wav')
        pushChimeAudio.preload = 'auto'
        pushChimeAudio.volume = 0.85
      }
      pushChimeAudio.muted = true
      const play = pushChimeAudio.play()
      if (play && typeof play.then === 'function') {
        play.then(() => {
          pushChimeAudio.pause()
          pushChimeAudio.currentTime = 0
          pushChimeAudio.muted = false
        }).catch(() => {
          pushChimeAudio.muted = false
        })
      }
    } catch (_) { /* ignore */ }
  }
  document.addEventListener('pointerdown', unlockPushChime, { once: true })
  document.addEventListener('keydown', unlockPushChime, { once: true })

  navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
    .then((registration) => {
      notifyStandaloneClient(registration)
      navigator.serviceWorker.ready.then(() => notifyStandaloneClient(registration))
    })
    .catch((error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Ebazzari service worker registration failed:', error)
      }
    })
}

if (document.readyState === 'complete') {
  registerServiceWorker()
} else {
  window.addEventListener('load', registerServiceWorker, { once: true })
}
